
        import { getConfig } from '@edx/frontend-platform';
        

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    addPlugins(config, 'learning_help_slot', [
        {
          op: PLUGIN_OPERATIONS.Hide,
          widgetId: 'default_contents',
        }]);
    addPlugins(config, 'learning_help_slot', [
        {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
              id: 'custom_help_link',
              type: DIRECT_PLUGIN,
              priority: 50,
              RenderWidget: () => (
                <a className="text-white" href={`${getConfig().LMS_BASE_URL}/support`}>Tech Support</a>
              ),
            },
        }]);
    addPlugins(config, 'learning_user_menu_slot', [
        {
            op: PLUGIN_OPERATIONS.Modify,
            widgetId: 'default_contents',
            // Receives the props that the default menu uses: { items, ... }
            fn: (props) => {
              const ORDER_HISTORY_URL = getConfig().ORDER_HISTORY_URL;
              const filtered = (props.items || []).filter(item => item.href !== ORDER_HISTORY_URL);
              return { ...props, items: filtered };
            },
        }]);
    addPlugins(config, 'learning_logged_out_items_slot', [
        {
            op: PLUGIN_OPERATIONS.Modify,
            widgetId: 'default_contents',
            fn: (widget) => {
                widget.content.buttonsInfo = [
                {
                    message: 'Sign In',
                    href: `${getConfig().LMS_BASE_URL}/login?next=${encodeURIComponent(global.location.href)}`,
                    variant: 'primary',
                },
                ];
                return widget;
            }
        }
        ]);
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
      addPlugins(config, 'org.openedx.frontend.learner_dashboard.no_courses_view.v1', [
            {
              op: PLUGIN_OPERATIONS.Hide,
              widgetId: 'default_contents',
            }]);
      addPlugins(config, 'org.openedx.frontend.learner_dashboard.no_courses_view.v1', [
            {
              op: PLUGIN_OPERATIONS.Insert,
              widget: {
                id: 'no_courses_fidget_spinner',
                type: DIRECT_PLUGIN,
                RenderWidget: () => (
                    <p>You are not enrolled in any courses.</p>
                ),
              },
            }]);
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'profile') {
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;